export const scanner = {
    bondFields: {
        "couponMin": "",
        "couponMax": "",
        "endDate": "",
        "startDate": "",
        "yieldMin": "",
        "yieldMax": "",
        "moodyLow": "",
        "moodyHigh": "",
        "spHigh": "",
        "spLow": "",
        "stateLabel": "",
        "issuerLabel": "",
        "currencyLabel": "",
        "industryLabel": "",
        "treasuryType": "",
        "cusipId": "",
        "cusip": ""
    },
    filters: {
        instrument: 'BOND',
        locations: 'BOND.WW',
        scanCode: 'HIGH_BOND_ASK_YIELD_ALL',
        secType: 'BOND',
        filters: [
            {
                "code": "maturityDateAbove",
                "value": ""
            },
            {
                "code": "maturityDateBelow",
                "value": ""
            },
            {
                "code": "industryLike",
                "value": ""
            },
            {
                "code": "bondAskYieldAbove",
                "value": ""
            },
            {
                "code": "bondAskYieldBelow",
                "value": ""
            },
            {
                "code": "couponRateAbove",
                "value": ""
            },
            {
                "code": "couponRateBelow",
                "value": ""
            },
            {
                "code": "moodyRatingAbove",
                "value": ""
            },
            {
                "code": "moodyRatingBelow",
                "value": ""
            },
            {
                "code": "spRatingAbove",
                "value": ""
            },
            {
                "code": "spRatingBelow",
                "value": ""
            },
            {
                "code": "currencyLike",
                "value": ""
            },
            {
                "code": "issuerCountryIs",
                "value": ""
            }
        ]
    }
}
